import styled from 'styled-components';

export const ContainerAcessibilidade = styled.div`
  display: ${props => (!props.changeLibras ? 'none' : 'inline-block')};
  margin-left: 10px;
  margin-top: 21px;
  font-size: 1.3em;

  .tooltip {
    position: relative;
    display: inline-block;
  }

  .tooltip .tooltipText {
    visibility: hidden;
    width: 300px;
    background-color: #108ee9;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 20px 5px;
    position: absolute;
    z-index: 1;
    bottom: 0%;
    left: 50%;
    margin-left: -150px;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 12pt;
  }

  .tooltip .tooltipText::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
  }

  .tooltip:hover .tooltipText {
    visibility: visible;
    opacity: 1;
  }
`;

export const ContainerIcon = styled.div`
  height: 20px;
  border-radius: 10px;
  text-align: center;
  background-color: transparent;
  display: ${props => (props.changeLibras ? 'none' : 'inline-block')};

  span {
    animation-name: color;
    animation-duration: 4s;
    animation-iteration-count: infinite;
  }

  @keyframes color {
    0% {
      color: #108ee9;
    }
    25% {
      color: #000000;
    }
    50% {
      color: #108ee9;
    }
    75% {
      color: #000000;
    }
    100% {
      color: #108ee9;
    }
  }
`;
